import { hasProperty } from 'spyrjari'

/**
 * Order grouped items by type.
 * Basic order defined by Happens,
 * rest just added after them.
 */
export const orderByTypes = (groupedItems) => {
  const order = [
    'Tilat',
    'Elämykset ja aktiviteetit',
    'Catering ja tarjoilut',
    'Muut',
  ]
  const orderedGroups = groupedItems

  orderedGroups.sort((a, b) => {
    if (!order.includes(a.title)) {
      order.push(a.title)
    }

    if (!order.includes(b.title)) {
      order.push(b.title)
    }

    return order.indexOf(a.title) - order.indexOf(b.title)
  })

  return orderedGroups
}

/**
 * Group cart items by service type
 */
export const groupByTypes = (items) => {
  const groupedItems = []
  const itemGroups = {}

  items.forEach((item) => {
    const serviceType =
      item.types && item.types.length > 0 ? item.types[0].name : 'Muut'

    if (!hasProperty(itemGroups, serviceType)) {
      itemGroups[serviceType] = []
    }

    itemGroups[serviceType].push(item)
  })

  // Return as array with entries of title & item array.
  Object.keys(itemGroups).forEach((key) => {
    groupedItems.push({
      title: key,
      items: itemGroups[key],
    })
  })

  return groupedItems
}

export default {
  groupByTypes,
  orderByTypes,
}
